import type { HomepageHeroState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/homepageHero';

export const INITIAL_STATE: HomepageHeroState = {
  byId: {},
};
